import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
   drawer: {
      '& .MuiDrawer-paper': {
         width: '80%',
         height: '100vh'
      }
   },
   container: {
      borderTop: `6px solid ${theme.palette.primary.main}`,
      padding: theme.spacing(2),
      width: '100%'
   },
   header: {
      flexWrap: 'nowrap',
      alignItems: 'center'
   },
   title: {
      gap: 10,
      alignItems: 'center',
      marginRight: theme.spacing(2)
   },
   subtitle: {
      fontWeight: 'bold',
      fontSize: 16,
      marginBottom: theme.spacing(2)
   },
   paper: {
      marginTop: theme.spacing(2),
      gap: 30,
      padding: '10px 20px',
      width: '100%'
   },
   table: {
      overflowY: 'auto',
      height: 'calc(100vh - 280px)',
      '& .MuiPaper-rounded .MuiGrid-root div' : {
         display: 'none'
      },
      '& thead th:last-child, & tbody td:last-child': {
         display: 'none'
      }
   }
}))
